/**
 * Wrapper de compatibilidade: a rota /tenant/crm/deals/import agora
 * abre a Central de Importação de Listas com a aba "Negócios" como
 * padrão.
 *
 * A implementação real vive em src/pages/lists/ListsHub.tsx e a
 * lógica original foi extraída para src/components/lists/DealListsTab.tsx.
 */

import ListsHub from '@/pages/lists/ListsHub';

export default function CrmDealsImport() {
  return <ListsHub defaultTab="deals" />;
}
